/**
 * The refusal `/api/auth/me` gives a genuine Microsoft account no person matches: 403 with `{"code": "account_not_set_up", ..., "email"}`.
 * KEYED ON THE CODE, NEVER ON THE 403: an inactive account, an expired external and an operator also answer 403 with their own screens.
 * Returns the address to show (empty when the token carried none), or `null` when the error is not that refusal.
 */
import axios from 'axios'

const ACCOUNT_NOT_SET_UP_CODE = 'account_not_set_up'

export function accountNotSetUpAddress(error: unknown): string | null {
  if (!axios.isAxiosError(error)) return null
  const detail: unknown = error.response?.data?.detail
  if (!detail || typeof detail !== 'object' || Array.isArray(detail)) return null
  const body = detail as { code?: unknown; email?: unknown }
  if (body.code !== ACCOUNT_NOT_SET_UP_CODE) return null
  return typeof body.email === 'string' ? body.email : ''
}
